import { createPromiseClient } from '@bufbuild/connect';
import { LmsConnectedClassAPIServiceV1 } from '@protos/learning_management/lms.connected.apis_connect';

import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';
import { ConnectTransportOptions } from '@bufbuild/connect-web';

const LmsConnectedClassAPIServiceV1Client = createPromiseClient(
  LmsConnectedClassAPIServiceV1,
  lmsTransport
);

export const useLmsConnectedClassAPIServiceV1ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsConnectedClassAPIServiceV1,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
